import { Component, OnInit, inject } from '@angular/core';
import {
  ButtonConfig,
  buttonsStaticConfig,
  inputErrorTypes,
  SelectOption,
  utils
} from '../../../global';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs';
import { UntypedFormBuilder, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DialogContainerComponent } from '../../components/dialog-container/dialog-container.component';
import { NgIf } from '@angular/common';
import { MessageComponent } from '../../components/message/message.component';
import { SelectInputComponent } from '../../components/inputs/select-input/select-input.component';
import { DateRangeInputComponent } from '../../components/inputs/date-range-input/date-range-input.component';

export interface NavRefreshDialogConfig {
  refresh: ((dateType, dateFrom, dateTo) => Observable<any>);
  lastRefreshDate: Date;
  showMessage?: boolean;
}

enum RefreshDateTypes {
  DEADLINE = 'deadline',
  SENDING = 'sending'
}

@Component({
    selector: 'slm-nav-refresh',
    templateUrl: './nav-refresh.dialog.html',
    imports: [DialogContainerComponent, NgIf, MessageComponent, FormsModule, ReactiveFormsModule, SelectInputComponent, DateRangeInputComponent]
})
export class NavRefreshDialog implements OnInit {
  private readonly dialogRef = inject<MatDialogRef<NavRefreshDialog>>(MatDialogRef);
  private readonly fb = inject(UntypedFormBuilder);
  data = inject<NavRefreshDialogConfig>(MAT_DIALOG_DATA);

  public readonly error = [inputErrorTypes.required, {name: 'wrongRange', message: 'INVOICE.NAV.RANGE_ERROR'}];
  public readonly buttons: Array<ButtonConfig> = [
    buttonsStaticConfig.close,
    {
      label: 'LBL_BTN.REFRESH',
      action: 'refresh',
      buttonStyle: 'primary',
      icon: null,
      testId: 'refreshButton'
    }
  ];

  public readonly dateTypeSelectOptions: Array<SelectOption> = [
    {
      label: 'INVOICE.NAV.REFRESH_TYPES.DEADLINE',
      value: RefreshDateTypes.DEADLINE
    },
    {
      label: 'INVOICE.NAV.REFRESH_TYPES.SENDING',
      value: RefreshDateTypes.SENDING
    }
  ];

  public form: UntypedFormGroup;
  public readonly maxDate = new Date();

  ngOnInit() {
    this.form = this.fb.group({
      dateType: [RefreshDateTypes.DEADLINE, [Validators.required]],
      date: this.fb.group({
        start: this.fb.control(this.data.lastRefreshDate || '', [Validators.required]),
        end: this.fb.control('')
      }, {
        validators: [((group) => {
          const startControl = group?.get('start');
          const endControl = group?.get('end');

          if (!startControl?.value) {
            endControl.setErrors(null);
            return null;
          }
          if (!endControl?.value) {
            endControl.setErrors(null);
            return null;
          }
          if (utils.dayDifferenceBtwnDates(new Date(startControl.value), new Date(endControl.value)) > 35) {
            endControl.setErrors({wrongRange: endControl.value});
            return null;
          }

          if (endControl.hasError('wrongRange')) {
            endControl.setErrors(null);
          }
          return null;
        })]
      })
    });
  }

  public buttonEvent(event: string) {
    if (event === buttonsStaticConfig.close.action) {
      this.dialogRef.close();
      return;
    }
    if (this.buttons[1].isLoading || this.form.invalid) {
      return;
    }
    this.dialogRef.disableClose = true;
    this.buttons[1].isLoading = true;
    const formValues = this.form.value;
    this.data.refresh(formValues.dateType, formValues.date.start, formValues.date.end).subscribe({
      next: () => {
        this.dialogRef.disableClose = false;
        this.buttons[1].isLoading = false;
        this.dialogRef.close(true);
      },
      error: () => {
        this.dialogRef.disableClose = false;
        this.buttons[1].isLoading = false;
      }
    });
  }
}
